export default __webpack_public_path__ + "static/media/5.16dd9807.jpg";